type FrontendTelemetryEvent = {
	timestamp: string;
	service: string;
	env: string;
	requestId: string;
	targetService: string;
	method: string;
	endpoint: string;
	statusCode: number;
	outcome: "success" | "client_error" | "server_error" | "network_error";
	durationMs: number;
	source: "browser" | "server";
};

const FRONTEND_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT || "dev";

export function createFrontendRequestId(): string {
	if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
		return crypto.randomUUID();
	}

	return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getFrontendObservabilityHeaders(requestId: string): Record<string, string> {
	return {
		"X-Request-ID": requestId,
		"X-Observability-Env": FRONTEND_ENV,
	};
}

export async function emitFrontendApiTelemetry(_event: Omit<FrontendTelemetryEvent, "timestamp" | "service" | "env" | "source">): Promise<void> {
	// Temporarily disabled: the browser telemetry endpoint is returning 403s in production.
	// Keeping this no-op preserves all existing API call sites without issuing network requests.
	return;
}

export function classifyFrontendOutcome(statusCode: number): FrontendTelemetryEvent["outcome"] {
	if (statusCode >= 200 && statusCode < 400) {
		return "success";
	}

	if (statusCode >= 400 && statusCode < 500) {
		return "client_error";
	}

	if (statusCode >= 500) {
		return "server_error";
	}

	return "network_error";
}
